import { render, staticRenderFns } from "./ReturnFromCustomer.vue?vue&type=template&id=6be6ee70&"
import script from "./ReturnFromCustomer.vue?vue&type=script&lang=ts&"
export * from "./ReturnFromCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be6ee70')) {
      api.createRecord('6be6ee70', component.options)
    } else {
      api.reload('6be6ee70', component.options)
    }
    module.hot.accept("./ReturnFromCustomer.vue?vue&type=template&id=6be6ee70&", function () {
      api.rerender('6be6ee70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/return-form-customer/ReturnFromCustomer.vue"
export default component.exports